import * as i0 from "@angular/core";
export class ForgotPasswordHomeStore {
}
ForgotPasswordHomeStore.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ForgotPasswordHomeStore_Factory() { return new ForgotPasswordHomeStore(); }, token: ForgotPasswordHomeStore, providedIn: "root" });
export var ForgotPasswordHomeStoreKeys;
(function (ForgotPasswordHomeStoreKeys) {
})(ForgotPasswordHomeStoreKeys || (ForgotPasswordHomeStoreKeys = {}));
